import { render, staticRenderFns } from "./ScaleArea.vue?vue&type=template&id=01bd46b4&scoped=true&"
import script from "./ScaleArea.vue?vue&type=script&lang=js&"
export * from "./ScaleArea.vue?vue&type=script&lang=js&"
import style0 from "./ScaleArea.vue?vue&type=style&index=0&id=01bd46b4&scoped=true&lang=css&"
import style1 from "./ScaleArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd46b4",
  null
  
)

export default component.exports